import { render, staticRenderFns } from "./ProgramAgreementHistory.vue?vue&type=template&id=21aa696d"
import script from "./ProgramAgreementHistory.vue?vue&type=script&lang=ts"
export * from "./ProgramAgreementHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports